import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/file.png'


const _withScopeId = n => (_pushScopeId("data-v-243871ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid p-col-12 p-mt-6" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-col-12" }
const _hoisted_4 = {
  class: "p-d-flex p-ai-center p-text-bold",
  style: {"color":"#8B8F8F"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"filter":"brightness(240%)","text-transform":"uppercase"}
  })
], -1))
const _hoisted_6 = { class: "p-d-flex p-ai-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "title" }
const _hoisted_9 = {
  key: 0,
  class: "title"
}
const _hoisted_10 = {
  key: 1,
  class: "title"
}
const _hoisted_11 = {
  class: "title",
  style: {"font-size":"12px"}
}
const _hoisted_12 = {
  class: "title",
  style: {"font-size":"12px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "button-more" }, "...")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SearchBar, {
        class: "p-col-9",
        onClearFilters: $setup.clearFilters,
        onSearchValue: $setup.searchValueChange,
        placeholder: 'Search for Campaign or Contract'
      }, null, 8, ["onClearFilters", "onSearchValue"]),
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_DataTable, {
          value: $setup.content,
          responsiveLayout: "scroll",
          rows: 8
        }, {
          empty: _withCtx(() => [
            _createTextVNode("No data found.")
          ]),
          loading: _withCtx(() => [
            _createTextVNode("Loading data... Please wait.")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "CAMPAIGN SUBMISSION",
              sortField: "number"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(" #LNA" + _toDisplayString(data?.id), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "BRAND",
              sortField: "brand.name"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_6, [
                  (data?.licenseRequests[data?.licenseRequests?.length - 1]?.brand?.photo.length > 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: data?.licenseRequests[data?.licenseRequests?.length - 1]?.brand?.photo,
                        class: "logo-brand"
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(data?.licenseRequests[data?.licenseRequests?.length - 1]?.brand?.name), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "LICENSE PERIOD",
              sortField: "period"
            }, {
              body: _withCtx(({ data }) => [
                (data?.licenseRequests[data?.licenseRequests?.length - 1]?.duration?.period)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(data?.licenseRequests[data?.licenseRequests?.length - 1]?.duration?.period) + " " + _toDisplayString(data?.licenseRequests[data?.licenseRequests?.length - 1]?.duration?.type), 1))
                  : _createCommentVNode("", true),
                (data?.licenseRequests[data?.licenseRequests?.length - 1]?.duration?.perpetual)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Infinity "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "STATUS",
              sortField: "status"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(data?.licenseRequests[data?.licenseRequests?.length - 1]?.status), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "PAYMENT",
              sortField: "status"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(data?.licenseRequests[data?.licenseRequests?.length - 1]?.offers[data?.licenseRequests[data
                  ?.licenseRequests?.length - 1]?.offers?.length - 1]?.price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, {
              body: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ])
  ]))
}